import { render, staticRenderFns } from "./scoringDetails.vue?vue&type=template&id=0262e8f4&scoped=true&"
import script from "./scoringDetails.vue?vue&type=script&lang=js&"
export * from "./scoringDetails.vue?vue&type=script&lang=js&"
import style0 from "./scoringDetails.vue?vue&type=style&index=0&id=0262e8f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0262e8f4",
  null
  
)

export default component.exports